// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { AssemblyJig } from './assembly-jig';
import { DeliveryOption } from './delivery-option';
import { DeliveryStack } from './delivery-stack';
import { Invoice } from './invoice';
import { InvoiceLine } from './invoice-line';
import { OrderLine } from './order-line';
import { OrderLineDetailNote } from './order-line-detail-note';
import { OrderLineDetailPart } from './order-line-detail-part';
import { OrderLineStatus } from './order-line-status';
import { PackingSlip } from './packing-slip';
import { PaymentLine } from './payment-line';
import { User } from './user';

/// <code-import> Place custom imports between <code-import> tags
import _ from 'lodash';
import moment from 'moment';
/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class OrderLineDetail extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  static Statuses = {
        InProcess: 1,
        Built: 2,
        Stacked: 3,
        Complete: 4,
        WaitingForPickup: 5, // not used anymore
        ReadyDeliverPickup: 6,
        WaitingOn: 8,
        DeliveredPickedUp: 9,
        New: 10,
        Winter: 11,
        PackSlipCreated: 12,
    };

    _displayOrder: number;
    get displayOrder() {
        if (!this._displayOrder) this._displayOrder = 10000 * (!!this.parentLine ? this.parentLineId : this.id) + this.id;
        return this._displayOrder;
    }
    get lineTotal() {
        return this.quantity * this.price;
    }
    get vinEndingDisplay() {
        return `${!!this.vIN ? this.vIN.substring(this.vIN.length - 7) : ''}`;
    }
    get paymentTotal() {
        let total = 0;
        if (!!this.paymentLines && this.paymentLines.length > 0) {
            this.paymentLines
                .filter((line) => line.deleted === null)
                .forEach((line) => {
                    total += line.amount;
                });
        }
        return total;
    }

    get balance() {
        return this.lineTotal - this.paymentTotal;
    }

    get paymentsList() {
        const paymentList = [];
        if (!!this.paymentLines && this.paymentLines.length > 0) {
            this.paymentLines
                .filter((line) => line.deleted === null)
                .forEach((paymentLine) => {
                    if (!_.includes(paymentList, paymentLine.paymentId)) paymentList.push(paymentLine.paymentId);
                });
        }
        return paymentList;
    }
    get buildPastDue() {
        if (this.buildDue) return this.buildDue < moment().startOf('day').toDate();
    }
    get shipPastDue() {
        if (this.dueDate) return this.dueDate < moment().startOf('day').toDate();
    }

    get deliveryId() {
        const stacks = this.deliveryStacks?.filter(s => !s.deleted);
        return stacks?.length > 0 ? stacks[0].deliveryId : null;
    }

    get invoiceNumberDisplay() {
        return !!this.invoice ? this.invoice.invoiceNumber : '';
    }
    get isScheduled() {
        return !!this.scheduled;
    }

    optionHTML: string;
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  acknowledged?: Date;
  acknowledgedById?: number;
  assemblyJigId?: number;
  buildComplete?: Date;
  buildDue?: Date;
  built?: Date;
  created?: Date;
  deleted?: Date;
  delivered?: Date;
  deliveryOptionId?: number;
  dueDate?: Date;
  hotOrder!: boolean;
  invoiceId?: number;
  isCredit!: boolean;
  isMisc!: boolean;
  isOption!: boolean;
  isReplacement!: boolean;
  note?: string;
  onHold?: Date;
  options?: string;
  orderLineId!: number;
  packingSlipId?: number;
  parentLineId?: number;
  partCount?: number;
  price!: number;
  processed?: number;
  quantity?: number;
  scheduleDisplayOrder?: number;
  scheduled?: Date;
  statusId?: number;
  tax!: number;
  transition?: Date;
  vIN?: string;
  acknowledgedBy!: User;
  assemblyJig!: AssemblyJig;
  deliveryOption!: DeliveryOption;
  deliveryStacks!: DeliveryStack[];
  invoice!: Invoice;
  invoiceLines!: InvoiceLine[];
  notes!: OrderLineDetailNote[];
  optionDetails!: OrderLineDetail[];
  orderLine!: OrderLine;
  packingSlip!: PackingSlip;
  parentLine!: OrderLineDetail;
  parts!: OrderLineDetailPart[];
  paymentLines!: PaymentLine[];
  status!: OrderLineStatus;
}

